/* eslint-disable import/prefer-default-export */
export const loginWithTwitchOAuthCode = (code, scope, token, query) => ({
  type: 'LOGIN_TWITCH_OAUTH_CODE',
  payload: {
    code,
    scope,
    token,
    query,
  },
});
export const loginWithTwitterOAuthCode = (oauth_token, oauth_verifier, token) => ({
  type: 'LOGIN_TWITTER_OAUTH_CODE',
  payload: {
    oauth_token,
    oauth_verifier,
    token,
  },
});

export const loginWithYoutubeOAuthCode = (code, scope, token, query) => ({
  type: 'LOGIN_YOUTUBE_OAUTH_CODE',
  payload: {
    code,
    scope,
    token,
    query,
  },
});

export const loginWithTikTokOAuthCode = (code, scope, token) => ({
  type: 'LOGIN_TIKTOK_OAUTH_CODE',
  payload: {
    code,
    scope,
    token,
  },
});

export const loginWithSteamOAuthCode = (openid_params, token) => ({
  type: 'LOGIN_STEAM_OAUTH_CODE',
  payload: {
    openid_params,
    token,
  },
});

export const signIn = payload => ({
  type: 'SIGN_IN',
  payload,
});

export const signInBefore = payload => ({
  type: 'SIGN_IN_BEFORE',
  payload,
});

export const signUp = userInfo => ({
  type: 'SIGN_UP',
  payload: {
    userInfo,
  },
});

export const recover = identity => ({
  type: 'RECOVER',
  payload: {
    ...identity,
  },
});

export const recoverValidate = recoveryToken => ({
  type: 'RECOVER_VALIDATE',
  payload: {
    recoveryToken,
  },
});

export const recoverChangePassword = (recoveryToken, password, rePassword) => ({
  type: 'RECOVER_CHANGE_PASSWORD',
  payload: {
    recoveryToken,
    password,
    rePassword,
  },
});

export const logout = (token) => ({
  type: 'LOGOUT',
  payload: {
    token,
  },
});

export const updateUserInfo = (userInfo, token) => ({
  type: 'UPDATE_USER_INFO',
  payload: {
    userInfo,
    token,
  },
});
export const updateInfoByUser = (userInfo, token) => ({
  type: 'UPDATE_USER_BYUSER_INFO',
  payload: {
    userInfo,
    token,
  },
});
export const setGlobalInit = () => ({
  type: 'GLOBAL_INIT',
});

export const getUserStats = username => ({
  type: 'GET_USER_STATISTICS',
  payload: {
    username,
  },
});

export const disconnectTwitch = (token, user) => ({
  type: 'TWITCH_DISCONNECTION',
  payload: {
    token,
    user,
  },
});

export const disconnectYoutube = (token, user) => ({
  type: 'YOUTUBE_DISCONNECTION',
  payload: {
    token,
    user,
  },
});

export const disconnectTwitter = (token, user) => ({
  type: 'TWITTER_DISCONNECTION',
  payload: {
    token,
    user,
  },
});
export const disconnectSteam = (token, user) => ({
  type: 'STEAM_DISCONNECTION',
  payload: {
    token,
    user,
  },
});
export const updateProfileInfo = (profileInfo, token) => ({
  type: 'UPDATE_PROFILE_INFO',
  payload: {
    profileInfo,
    token,
  },
});

export const validateUserHandshake = (token, handshake) => ({
  type: 'VALIDATE_USER_HANDSHAKE',
  payload: {
    token,
    handshake,
  },
});

// export const sendVerificationCode = (token,verificationType,isVerExp=false) => ({
//   type: 'SEND_VERIFICATION_CODE',
//   payload: {
//     token,
//     verificationType,
//     isVerExp
//   },
// });
export const sendVerificationCode = (token, verificationType, isVerExp = false, targetEmail = '') => {
  return {
    type: 'SEND_VERIFICATION_CODE',
    payload: {
      token,
      verificationType,
      isVerExp,
      targetEmail,
    },
  };
};

export const validateVerificationCode = (token, verificationCode, verificationType) => ({
  type: 'VALIDATE_VERIFICATION_CODE',
  payload: {
    token,
    verificationCode,
    verificationType
  },
});

export const getCDK = (orderId) => ({
  type: 'GET_CDK',
  payload: {
    orderId,
  },
});

export const signOut = (token) => ({
  type: 'SIGN_OUT',
  payload: {
    token,
  },
});

export const refreshYoutubeAvgPlayCount = (token, force = false) => ({
  type: 'REFRESH_YOUTUBE_AVG_PLAYCOUNT',
  payload: {
    token,
    force,
  },
});

export const bindTwitchPlatform = (token, gameId, gamePlatform) => ({
  type: 'BIND_TWITCH_PLATFORM',
  payload: {
    token,
    gameId,
    gamePlatform,
  },
});
